import { axiosClient } from "@/lib/axios";
import { HttpError } from "@/types/error";
import { PublicAnnouncement } from "@classview/shared-types";
import { UseQueryOptions, useQuery } from "@tanstack/react-query";

const getAnnouncement = async (id: string): Promise<PublicAnnouncement> => {
  const response = await axiosClient.get(`/announcements/${id}`);
  return response.data;
};

export const getAnnouncementQueryKey = (id: string) => ["announcement", id];

export function useGetAnnouncement(
  { id }: { id: string },
  queryOptions?: Partial<UseQueryOptions<PublicAnnouncement, HttpError>>,
) {
  return useQuery({
    queryKey: getAnnouncementQueryKey(id),
    queryFn: () => getAnnouncement(id),
    ...queryOptions,
  });
}
